import { Tag } from 'antd'
import { Job as JobModel } from '../../models/Job'

interface Props {
  model: JobModel
}

export const JobTag = ({ model }: Props) => {
  const item = model

  if (!item) {
    return <Tag>Poste supprimé</Tag>
  }

  return <Tag color="pink">{item.name}</Tag>
}

export type JobTagType = { Tag: typeof JobTag }
